import { ShortCode } from '@highereducation/wordpress';
import { Brow } from '@highereducation/hen-ui';

type BrowShortcodeProps = {
  color?: 'default' | 'white';
  align?: 'left' | 'center' | 'right';
  children?: React.ReactNode;
};

/**
 * BrowShortcode - Shortcode wrapper for Brow atomic component
 *
 * Supported shortcode attributes:
 * - color: 'default' | 'white' (default: 'default') - Text color
 * - align: 'left' | 'center' | 'right' - Text alignment
 *
 * @example WordPress shortcode usage:
 * [hen-ui-brow]Section Label[/hen-ui-brow]
 * [hen-ui-brow color="white"]White Section Label[/hen-ui-brow]
 * [hen-ui-brow align="center"]Centered Label[/hen-ui-brow]
 */
export const BrowShortcode: ShortCode<BrowShortcodeProps> = {
  component: ({ color, align, children }) => {
    // Brow requires string children - convert if needed
    const textContent =
      typeof children === 'string' ? children : String(children ?? '');

    return (
      <Brow color={color} align={align}>
        {textContent}
      </Brow>
    );
  },
};
